import styled, { css } from 'styled-components';
import { Button as ButtonAntd } from 'antd';
import color from '../../configs/color';
import boxShadow from '../../configs/boxShadow';

const Button = styled(ButtonAntd)`
  border-radius: 12px;
  padding: 11px 28px;
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  text-shadow: none;
  min-width: ${(props) => {
    return props.minWidth ? `${props.minWidth}px` : 'initial';
  }};

  ${(props) => {
    return (
      props.type === 'primary' &&
      css`
        background-color: ${color.orange2};
        border-color: ${color.orange2};
        color: ${color.white};
        box-shadow: ${boxShadow.color};
        :hover,
        :focus,
        :active {
          background-color: ${color.orange1};
          border-color: ${color.orange1};
        }
      `
    );
  }}

  ${(props) => {
    return (
      props.size === 'small' &&
      css`
        height: 38px;
        padding: 8px 28px;
      `
    );
  }}
  ${(props) => {
    return (
      (props.type === 'default' || props.type === 'primary-alt') &&
      css`
        background: ${color.white};
        border-color: ${color.green1};
        color: ${color.green1};
        box-shadow: 0px 2px 16px -4px rgba(23, 30, 41, 0.08);
        :hover,
        :focus,
        :active {
          color: ${color.white};
          background-color: ${color.green1};
          border-color: ${color.green1};
        }
      `
    );
  }}
  ${(props) => {
    return (
      (props.type === 'secondary' || props.type === 'primary-alt') &&
      css`
        border-color: ${color.grey1};
        background-color: ${color.grey1};
        color: ${color.black1};
        box-shadow: 0px 2px 16px -4px rgba(23, 30, 41, 0.08);
        :hover,
        :focus,
        :active {
          color: ${color.black2};
          border-color: ${color.grey2};
          background-color: ${color.black6};
        }
      `
    );
  }}
  ${(props) => {
    return (
      props.type === 'danger' &&
      css`
        border-color: ${color.red2};
        background-color: ${color.red2};
        /* box-shadow: 0px 2px 16px -4px rgba(23, 30, 41, 0.08); */
        :hover,
        :focus,
        :active {
          border-color: ${color.red3};
          background-color: ${color.red3};
        }
      `
    );
  }}
  ${(props) => {
    return (
      props.type === 'success' &&
      css`
        border-color: ${color.green1};
        background-color: ${color.green1};
        color: ${color.white};
        /* box-shadow: 0px 2px 16px -4px rgba(23, 30, 41, 0.08); */
        :hover,
        :focus,
        :active {
          color: ${color.white};
          border-color: ${color.green1};
          background-color: ${color.green1};
          opacity: 0.9;
        }
      `
    );
  }}

${(props) => {
    return (
      props.type === 'success' &&
      props.disabled &&
      css`
        border-color: ${color.green5} !important;
        background-color: ${color.green5} !important;
        color: ${color.white} !important;
      `
    );
  }}

${(props) => {
    return (
      props.type === 'primary' &&
      props.disabled &&
      css`
        background-color: ${color.orange5} !important;
        border-color: ${color.orange5} !important;
        color: white !important;
      `
    );
  }}

  &.component_button_default_transparent {
    background: transparent;
    border-color: ${color.green1};
    color: ${color.green1};
    box-shadow: 0px 2px 16px -4px rgba(23, 30, 41, 0.08);
    :hover,
    :focus,
    :active {
      color: ${color.white};
      background-color: ${color.green1};
      border-color: ${color.green1};
    }
  }

  &.component_button_primary_transparent {
    background: transparent;
    border-color: ${color.orange1};
    color: ${color.orange1};
    box-shadow: 0px 2px 16px -4px rgba(23, 30, 41, 0.08);
    :hover,
    :focus,
    :active {
      color: ${color.white};
      background-color: ${color.orange1};
      border-color: ${color.orange1};
    }
  }
  ${(props) => {
    return (
      props.type === 'white' &&
      css`
        border-color: ${color.white};
        background-color: ${color.white};
        font-weight: 400;
        color: ${color.black2};
        box-shadow: ${boxShadow.normal};
        :hover,
        :focus,
        :active {
          border-color: ${color.white};
          background-color: ${color.white};
          color: ${color.black3};
        }
      `
    );
  }}
  ${(props) => {
    return (
      props.type === 'white2' &&
      css`
        border-color: ${color.green1};
        background-color: ${color.white};
        font-weight: 400;
        color: ${color.green1};
        box-shadow: ${boxShadow.normal};
        :hover,
        :focus,
        :active {
          border-color: ${color.green2};
          background-color: ${color.white};
          color: ${color.green2};
        }
      `
    );
  }}
  ${(props) => {
    return (
      props.type === 'link orange' &&
      css`
        color: ${color.orange1};
        :hover,
        :focus,
        :active {
          color: ${color.orange1};
          opacity: 0.9;
        }
      `
    );
  }}

${(props) => {
    return (
      props.type === 'orange-border' &&
      css`
        color: ${color.orange1};
        border: 1px solid ${color.orange1};
        :hover,
        :focus,
        :active {
          color: ${color.orange1};
          border: 1px solid ${color.orange2};
          opacity: 0.9;
        }
      `
    );
  }}
${(props) => {
    return (
      props.type === 'danger-border' &&
      css`
        color: ${color.red2};
        border: 1px solid ${color.red2};
        :hover,
        :focus,
        :active {
          color: ${color.red3};
          border: 1px solid ${color.red3};
          opacity: 0.9;
        }
      `
    );
  }}

  &.component_button_without_text {
    padding: 11px 14px !important;
    min-width: unset !important;
    width: auto;
    .anticon-message {
      svg {
        font-size: 20px;
        color: ${color.black2};
      }
    }
  }

  &.component_button_without_shadow {
    box-shadow: none;
  }

  &.component_button_href {
    padding-top: unset !important;
    line-height: 44px;
  }
`;

export default Button;
